(ns practitest.frontend.account-dashboard-settings.events
  (:require
   [re-frame.core              :as re-frame]
   [ajax.core                  :as ajax]
   [practitest.frontend.common-old-fe.logging    :as log]))

;; ===========================================================================
;; interceptors

(def common-interceptors
  [(when ^boolean js/goog.DEBUG re-frame/debug)
   re-frame/trim-v])

(re-frame/reg-event-db
  :account-dashboard-settings/init-complete
  (fn [db _]
    (assoc db :init-complete? true)))

(re-frame/reg-event-db
 :account-dashboard-settings/initialize
 common-interceptors
 (fn [db [options]]
   (log/info ":account-dashboard-settings/initialize" options db (js->clj js/window._pt :keywordize-keys true))
   (dissoc (merge options db))))

(re-frame/reg-event-db
 :account-dashboard-settings/add-val
 common-interceptors
 (fn [db [key val]]
   (let [avaliable-list  (dissoc (:avaliable-list db) key)
         display-list    (assoc (:display-list db) key val)]
     (assoc db :avaliable-list avaliable-list
            :display-list display-list))))

(re-frame/reg-event-db
 :account-dashboard-settings/remove-val
 common-interceptors
 (fn [db [key val]]
   (let [avaliable-list  (assoc  (:avaliable-list db) key val)
         display-list    (dissoc (:display-list db) key)]
     (assoc db :avaliable-list avaliable-list
            :display-list display-list))))

(re-frame/reg-event-db
 :account-dashboard-settings/set-account-message
 common-interceptors
 (fn [db [val]]
   (assoc db :account-message val)))

(re-frame/reg-event-db
 :account-dashboard-settings/toggle-enable-val
 common-interceptors
 (fn [db _]
   (assoc db :account-message-enable (not (:account-message-enable db)))))

(re-frame/reg-event-fx
 :account-dashboard-settings/update-account
 common-interceptors
 (fn [{:keys [db]} _]
   (let [params {:account_message        (:account-message db)
                 :account_message_enable (:account-message-enable db)
                 :display_list           (or (keys (:display-list db)) [])}
         uri    (:update-uri db)]
     {:http-xhrio {:method          :post
                   :uri             uri
                   :params          params
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [:account-dashboard-settings/set-message "Settings were successfuly saved" :success-message]
                   :on-failure      [:account-dashboard-settings/set-message "Something went wrong" :failure-message]}})))
(re-frame/reg-event-fx
 :account-dashboard-settings/set-message
 common-interceptors
 (fn [{:keys [db]} [message message-key]]
   {:db (assoc db message-key message)
    :dispatch-later [{:ms 9000 :dispatch [:account-dashboard-settings/remove-alert message-key]}]}))

(re-frame/reg-event-db
 :account-dashboard-settings/remove-alert
 []
 (fn [db [_ message-key]]
   (dissoc db message-key)))

(re-frame/reg-event-db
 :account-dashboard-settings/update-search-val
 []
 (fn [db [_ search-key search-val]]
   (assoc db search-key search-val)))
